import { useEffect, useState } from "react";
import { Card, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import ReAssessmentFilter from "../../app/re-assessment/ReAssessmentFilter";
import ReAssessmentGrid from "../../app/re-assessment/ReAssessmentGrid";
import ReAssessmentStats from "../../app/re-assessment/ReAssessmentStats";
import AppConfig from "../../core/service/AppConfig";

/**
 * "Rapor Operasyonları → Yeniden Değerlendirme".
 *
 * Tüm liste ve istatistik işi burada; rapor ekranına kolon eklenmedi. Erişim tek yetkiye bağlı
 * (RE_ASSESSMENT_MANAGE) — yönlendirme AppRouter'da da aynı yetkiyle korunuyor.
 */
export default function ReAssessmentPage() {
    const { t } = useTranslation();

    // İstatistik sekmesi grid'in queryModel'ine değil, filtrenin yaydığı ham filtreye bakar;
    // ikisi de aynı normalizasyondan geçer (re-assessment-filter-query).
    const [filter, setFilter] = useState(null);

    useEffect(() => {
        document.title = `${t('Re-Assessment')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <DataGridProvider>
            <LayoutWithSider
                fullWidth={true}
                sidebarTitle={t('Re-Assessment Filter')}
                sidebarComponent={<ReAssessmentFilter onFilterChanged={setFilter} />}
            >
                <Card title={t('Re-Assessment')}>
                    <Tabs
                        items={[
                            {
                                key: 'list',
                                label: t('List'),
                                children: <ReAssessmentGrid />,
                            },
                            {
                                key: 'stats',
                                label: t('Statistics'),
                                children: <ReAssessmentStats filter={filter} />,
                            },
                        ]}
                    />
                </Card>
            </LayoutWithSider>
        </DataGridProvider>
    )
}
